/**
 * Business rule identifiers.
 *
 * The backend puts one of these into `ProblemDetails.violatedRule`; the frontend
 * uses the same constant to pick the human-readable message. Adding a rule on one
 * side without the other is a type error.
 */
export const RULE_OVERLAP = 'RULE_OVERLAP';
export const RULE_TURNAROUND = 'RULE_TURNAROUND';
export const RULE_PILOT_LICENSE = 'RULE_PILOT_LICENSE';
export const RULE_CAPACITY = 'RULE_CAPACITY';
export const RULE_MAINTENANCE = 'RULE_MAINTENANCE';
export const RULE_AIRSHIP_NOT_BOOKABLE = 'RULE_AIRSHIP_NOT_BOOKABLE';
export const RULE_SLOT_BOUNDS = 'RULE_SLOT_BOUNDS';
export const RULE_SLOT_IN_PAST = 'RULE_SLOT_IN_PAST';
export const RULE_INVALID_TRANSITION = 'RULE_INVALID_TRANSITION';
/** BR-09: the approval window closed, so the request can no longer be decided. */
export const RULE_APPROVAL_EXPIRED = 'RULE_APPROVAL_EXPIRED';
export const BUSINESS_RULES = [
    RULE_OVERLAP,
    RULE_TURNAROUND,
    RULE_PILOT_LICENSE,
    RULE_CAPACITY,
    RULE_MAINTENANCE,
    RULE_AIRSHIP_NOT_BOOKABLE,
    RULE_SLOT_BOUNDS,
    RULE_SLOT_IN_PAST,
    RULE_INVALID_TRANSITION,
    RULE_APPROVAL_EXPIRED,
];
/** Human-readable rule labels (Czech) — rendered by the frontend. */
export const RULE_LABELS = {
    RULE_OVERLAP: 'Vzducholoď už má v tomto čase potvrzenou jinou rezervaci.',
    RULE_TURNAROUND: 'Mezi rezervacemi téže vzducholodě musí být povinná pozemní obsluha (turnaround).',
    RULE_PILOT_LICENSE: 'Pilot nemá licenci potřebnou pro tuto třídu vzducholodě.',
    RULE_CAPACITY: 'Počet pasažérů převyšuje kapacitu vzducholodě.',
    RULE_MAINTENANCE: 'Vzducholoď má v tomto termínu naplánovaný servis.',
    RULE_AIRSHIP_NOT_BOOKABLE: 'Vzducholoď není k dispozici k rezervaci.',
    RULE_SLOT_BOUNDS: 'Délka rezervace musí být mezi 2 hodinami a 14 dny.',
    RULE_SLOT_IN_PAST: 'Rezervaci nelze založit do minulosti.',
    RULE_INVALID_TRANSITION: 'Tento stavový přechod rezervace není povolený.',
    RULE_APPROVAL_EXPIRED: 'Lhůta pro schválení rezervace už uplynula.',
};
/** Minimum / maximum slot length and the default ground turnaround. */
export const SLOT_MIN_HOURS = 2;
export const SLOT_MAX_DAYS = 14;
export const DEFAULT_TURNAROUND_MINUTES = 240;
/**
 * BR-09: how long an Approver has to decide.
 *
 * A chosen value, not a measured one — the rental promises an answer within two
 * working days. The effective deadline is the earlier of this and departure; see
 * `approvalDeadline()` in the API domain layer for the retroactive exception.
 */
export const APPROVAL_WINDOW_HOURS = 48;
//# sourceMappingURL=rules.js.map